export default {
  metaTitleBrand: "LOYA SPORT",
  metaTitleHome: "الرئيسية",
  metaTitleProducts: "المنتجات",
  metaTitleProductDetail: "تفاصيل المنتج",
  metaTitleCustomService: "خدمة مخصصة",
  metaTitleSolutions: "الحلول",
  metaTitleAbout: "من نحن",
  metaTitleContact: "اتصل بنا",
  metaTitleBlog: "المدونة",
  metaTitleLogin: "تسجيل الدخول",
  metaTitleAdmin: "لوحة الإدارة",
  metaTitleSystemSetup: "إعداد النظام",
  contactDocsTitle: "المستندات المتاحة",
  contactDocsDesc: "الفاتورة التجارية وقائمة التعبئة ودعم تنسيق الشحن.",
  contactSampleTitle: "خدمة العينات",
  contactSampleDesc: "تنسيق سريع للعينات لمشاريع OEM والعلامة الخاصة.",
  searchOverlayPlaceholder: "ابحث عن المنتجات بالاسم...",
  searchOverlaySubmitAria: "إرسال البحث",
  searchOverlaySubmitTitle: "بحث",
  searchOverlayHintPrefix: "اضغط",
  searchOverlayHintSuffix: "لعرض جميع المنتجات المطابقة، أو اختر نتيجة سريعة من الأسفل.",
  searchOverlayCloseAria: "إغلاق البحث",
  searchOverlayQuickResults: "نتائج سريعة",
  searchOverlayQuickResultsAria: "نتائج البحث السريعة",
  searchOverlayFallbackCategory: "إكسسوارات اليوغا",
  searchOverlayHistory: "سجل البحث",
  searchOverlayClear: "مسح",
  searchOverlayNoHistory: "لا توجد عمليات بحث حديثة",
  searchOverlayRecommended: "كلمات مفتاحية مقترحة",
  searchOverlayFallbackKeyword: "سجادة يوغا",
  blogHeroKicker: "مركز المحتوى",
  blogHeroTitle: "رؤى وأدلة الشراء",
  blogSearchAria: "البحث في المقالات",
  blogReadingTimeMin: "دقائق قراءة",
  blogShowLess: "عرض أقل",
  blogCategoryAria: "فئات المقالات",
  blogFeaturedPlaceholder: "رؤية مميزة",
  blogPaginationAria: "ترقيم صفحات المدونة",
  blogCtaAria: "دعوة لاتخاذ إجراء في المدونة",
  blogCtaDescription: "يمكن لفريقنا تقديم توصيات عملية ومرافقة من مرحلة العينات حتى التسليم الكمي.",
  blogCtaPrimary: "تواصل الآن",
  blogCtaSecondary: "استكشف الحلول",
  requestFreeSample: "طلب عينة مجانية",
  factoryStatsSince: "التصدير منذ 2008",
  factoryStatsCapacity: "أكثر من 10,000 وحدة شهريًا",
  factoryStatsExport: "خدمة أكثر من 50 دولة",
  factoryStatsCert: "معتمد ISO 9001 وBSCI",
  aboutHeroTitle: "شباب، احتراف، تركيز — خبراؤك في تكامل سلسلة توريد اليوغا",
  aboutHeroBody: "تقع LOYA SPORT في تشانغشا، هونان، الصين، وتضم فريقًا حيويًا واحترافيًا. نحن ملتزمون بتقديم خدمات تكامل سلسلة توريد اليوغا للمشترين الدوليين بعناية عالية، بدءًا من فحص المصانع المصدرية وصولًا إلى التطوير المخصص المتعمق.",
  aboutAddress: "العنوان: مبنى رويه كيتشوانغ، طريق وانغ لونغ، حي يويلو، تشانغشا، هونان، الصين",
  aboutTeamTitle: "فريق حيوي واحترافي",
  aboutTeamBody: "نحن فريق شاب لكنه ذو خبرة، ويمتلك فهمًا عميقًا لاحتياجات السوق والتفاصيل التقنية في صناعة اليوغا. ومن خلال منطق اختيار صارم وسرعة استجابة فعالة، نضمن أن كل منتج نقدمه يلبّي توقعات تجارية عالية.",
  aboutCustomizationTitle: "خدمات تخصيص شاملة",
  aboutCustomizationBody: "من طباعة الشعار وتصميم التغليف إلى تطوير قوالب وظائف المنتج، نقدم حلول تخصيص مرنة وعميقة تساعد علامتك التجارية على التميز في السوق.",
  aboutFactoryPartnerTitle: "شركاء مصانع متميزون",
  aboutFactoryPartnerBody: "نعمل عن قرب مع قواعد تصنيع معتمدة وفق ISO/BSCI، ونضبط الجودة من المصدر لضمان استقرار الإنتاج والتسليم في الوقت المحدد.",
  aboutHeroKicker: "مُكامل سلسلة التوريد",
  aboutMetric1: "نافذة مشروع موحدة للتواصل بشأن المنتج والتغليف والتسليم",
  aboutMetric2: "تنسيق موارد المصانع ضمن هيكل واحد للشراء والمتابعة",
  aboutMetric3: "سير عمل مصمم للمستوردين وتجار التجزئة والموزعين ومشتري العلامة الخاصة",
  aboutPlaceholderNote: "دورنا هو تقليل تشتت التواصل بين المشتري والمورد وفرق تنفيذ المصنع، بحيث تسير المشاريع بوضوح أكبر ونقاط عمياء أقل.",
  aboutHeroImageAlt: "اجتماع تنسيق سلسلة التوريد للمشترين الدوليين",
  aboutHeroCaption: "من الاستفسار حتى الشحن، نحن ننسق التفاصيل التي غالبًا ما تتوزع بين وكلاء التوريد والمصانع وجهات اللوجستيات.",
  aboutOfficeImageAlt: "مبنى مكتب تشانغشا لويا للتكنولوجيا",
  aboutOfficeCaption: "مكتب تشانغشا لويا للتكنولوجيا",
  aboutTeamImageAlt: "فريقنا الاحترافي في مكتب تشانغشا",
  aboutFactoryImageAlt: "خط إنتاج سجادات اليوغا وسير عمل الجودة",
  aboutFactoryCollageAlt: "مستودع المصنع وتفاصيل الإنتاج",
  aboutWhatWeDoTitle: "ما الذي نقوم به فعليًا",
  aboutWhatWeDoBody1: "كثير من المشترين لا يحتاجون مجرد كتالوج. إنهم يحتاجون إلى شريك يستطيع ربط المتطلبات التجارية بالتنفيذ الفعلي داخل المصنع. وهنا يأتي دورنا. نحن ننسق اختيار الموردين، ومناقشات التسعير، وعينات المنتجات، وتنفيذ التغليف، ومتابعة الإنتاج، ومواءمة الفحص، والاستعداد للتصدير.",
  aboutWhatWeDoBody2: "بدلًا من ترك تفاصيل المنتج وملفات التغليف وتوقيت التسليم وتغييرات الطلب موزعة بين جهات اتصال متعددة، نقوم نحن بتجميع العملية في مسار اتصال واحد واضح ومسؤول لضمان استمرار تقدم المشروع.",
  aboutBadge1: "مطابقة الموردين",
  aboutBadge2: "متابعة العينات",
  aboutBadge3: "تنفيذ التغليف",
  aboutBadge4: "الاستعداد للشحن",
  aboutSideImageAlt: "تواصل المشتري ومراجعة المشروع",
  aboutIntegratedCapabilitiesTitle: "قدرات توريد متكاملة",
  aboutSideCaption: "نركز على جعل سلسلة التوريد أسهل إدارة للمشترين الدوليين الذين يحتاجون إلى تنسيق موثوق أكثر من مجرد نشاط تجاري منفصل.",
  aboutCapabilityCard1Title: "تكامل شبكة الموردين",
  aboutCapabilityCard1Body: "نجمع موارد المصانع والمعرفة الفئوية وضوابط التوريد ضمن سير عمل واحد موجه للمشتري، حتى لا تضطر إلى التنسيق بين عدة أطراف بنفسك.",
  aboutCapabilityCard2Title: "تنسيق تجاري وتقني",
  aboutCapabilityCard2Body: "من عرض الأسعار والعينات وتفاصيل التغليف إلى تأكيد المواصفات ونقاط التحقق أثناء الإنتاج، نبقي الجانبين التجاري والتصنيعي في توافق مستمر.",
  aboutCapabilityCard3Title: "تنفيذ طلبات التصدير",
  aboutCapabilityCard3Body: "نتابع الطلبات عبر الفحص والمستندات والحجز والاستعداد للشحن لتقليل فجوات التواصل ومخاطر التسليم.",
  aboutOperatingModel1: "توريد الفئات ومطابقة المصانع وفقًا لسوقك المستهدف وتموضعك السعري.",
  aboutOperatingModel2: "تنسيق العينات ومراجعة المواصفات والتغليف قبل تثبيت الإنتاج.",
  aboutOperatingModel3: "متابعة الإنتاج ونقاط فحص الجودة والتحضير للشحن ضمن تدفق مشروع واحد.",
  aboutOperatingModel4: "نافذة تواصل واحدة للمنتج والتغليف والمستندات وتقدم التسليم.",
  aboutWhoWeServeTitle: "من نخدم",
  aboutBuyerScenario1Title: "للمستوردين والموزعين",
  aboutBuyerScenario1Body: "نساعد على توحيد خطوط المنتجات، ومقارنة خيارات الموردين، وبناء خطة إعادة توريد أكثر استقرارًا عبر الفئات.",
  aboutBuyerScenario2Title: "لسلاسل التجزئة وبائعي التجارة الإلكترونية",
  aboutBuyerScenario2Body: "ندعم تشكيلات جاهزة للإطلاق، وتغليف العلامة الخاصة، وتواصلًا عمليًا للطلبات القابلة للتكرار.",
  aboutBuyerScenario3Title: "للعلامات التجارية التي توسّع خطوط منتجاتها",
  aboutBuyerScenario3Body: "نعمل كطبقة تنسيق بين فكرتك والجانب التصنيعي وتنفيذ التصدير حتى تتحرك الفرق الداخلية بسرعة أكبر.",
  aboutWorkflowTitle: "كيف تم تنظيم سير عملنا",
  aboutWorkflowStep1: "استلام المتطلبات وتوضيح المنتج المستهدف",
  aboutWorkflowStep2: "مطابقة الموردين وعرض الأسعار وتخطيط العينات",
  aboutWorkflowStep3: "مراجعة المواصفات والتغليف والامتثال",
  aboutWorkflowStep4: "متابعة الإنتاج والفحص والاستعداد للشحن",
  aboutWhyIntegratorTitle: "لماذا يستخدم المشترون مُكامل سلسلة توريد",
  aboutWhyIntegratorBody1: "عندما يمتد التوريد عبر عدة موردين وموردي تغليف وجداول شحن متعددة، فإن أكبر المخاطر غالبًا لا تكون في أول عرض سعر، بل في فقدان التوافق بعد بدء تحرك الطلب.",
  aboutWhyIntegratorList1: "قد تنحرف المواصفات بين عرض السعر والإنتاج.",
  aboutWhyIntegratorList2: "قد تتأخر تفاصيل التغليف والعلامة التجارية بسبب تشتت التواصل.",
  aboutWhyIntegratorList3: "قد تنفصل أعمال الفحص والأوراق والاستعداد للشحن عن الوعد التجاري الأصلي.",
  aboutWhyIntegratorBody2: "قيمتنا هي الحفاظ على اتصال هذه الأجزاء معًا. نحن نعمل كطبقة تنسيق بين توقعات المشتري وتنفيذ المورد، بحيث يتم توثيق القرارات ومتابعة الجداول الزمنية وتقليل مخاطر التسليم بين المراحل.",
  aboutTalkToTeam: "تحدث مع فريقنا",
  aboutPositioningTitle: "تموضعنا",
  aboutPositioningBody: "تتموضع LOYA SPORT كمُكامل سلسلة توريد لمنتجات اللياقة الموجهة للتصدير. نحن نساعد العملاء على الشراء بتنسيق أوضح وتنظيم أقوى للموردين ومسار أكثر قابلية للإدارة من التوريد حتى الشحن.",
  solutionsHeroKicker: "الحلول",
  solutionsHeroTitle: "اختر مسار التوريد المناسب لنوع المشتري لديك",
  solutionsHeroBody: "مصمم كدليل بصري لملاءمة القنوات، وملاءمة السيناريو، وتخطيط برامج المنتجات.",
  solutionsTalkToSales: "تحدث إلى المبيعات",
  solutionsBrowseProducts: "تصفح المنتجات",
  solutionsHeroImageAlt: "حلول توريد B2B لمشتري اليوغا واللياقة الخفيفة",
  solutionsHeroBadgeTitle: "ملاءمة الحل",
  solutionsHeroBadgeBody: "نوع المشتري + حالة الاستخدام + التشكيلة",
  solutionsBuyerTypeTitle: "حلول حسب نوع المشتري",
  solutionsViewMatchingProducts: "عرض المنتجات المطابقة",
  solutionsScenarioPlansTitle: "خطط السيناريوهات",
  solutionsProgramMixesTitle: "برامج المنتجات الموصى بها",
  solutionsNextStepKicker: "الخطوة التالية",
  solutionsNextStepTitle: "هل تحتاج إلى تشكيلة مخصصة لسوقك؟",
  solutionsNextStepBody: "شارك معنا نوع المشتري والمنتجات المستهدفة وسوق الوجهة، وسنقترح عليك مسار تشكيلة عملي.",
  solutionsRequestPlan: "اطلب خطة حلول",
  solutionsExploreOem: "استكشف دعم OEM",
  solutionsBuyerCard1Title: "تجار الجملة",
  solutionsBuyerCard1Subtitle: "بناء سريع للتشكيلة للبرامج الكمية.",
  solutionsBuyerCard1Need1: "يحتاجون إلى توريد كمي مستقر مع تقليل مخاطر نفاد المخزون",
  solutionsBuyerCard1Need2: "يحتاجون إلى مجموعات SKU جاهزة بالكرتون لتسريع إعادة البيع",
  solutionsBuyerCard1Need3: "يحتاجون إلى دورات إعادة طلب متكررة بزمن توريد متوقع",
  solutionsBuyerCard1Tag1: "تشكيلات كميات",
  solutionsBuyerCard1Tag2: "عبوات جاهزة بالكرتون",
  solutionsBuyerCard1Tag3: "إعادة توريد متكررة",
  solutionsBuyerCard2Title: "تجار التجزئة",
  solutionsBuyerCard2Subtitle: "عبوات جاهزة للرف وتجديد توريد مستقر.",
  solutionsBuyerCard2Need1: "يحتاجون إلى سلالم سعرية واضحة من الفئة الاقتصادية حتى الممتازة",
  solutionsBuyerCard2Need2: "يحتاجون إلى تغليف جاهز بالباركود لتسريع الإدراج على الرفوف",
  solutionsBuyerCard2Need3: "يحتاجون إلى إعادة توريد موثوقة للمنتجات سريعة الحركة",
  solutionsBuyerCard2Tag1: "عبوات تجزئة",
  solutionsBuyerCard2Tag2: "دعم الباركود",
  solutionsBuyerCard2Tag3: "تشكيلات مناسبة للعرض",
  solutionsBuyerCard3Title: "علامات اللياقة التجارية",
  solutionsBuyerCard3Subtitle: "برامج علامة خاصة لتوسيع العلامة.",
  solutionsBuyerCard3Need1: "يحتاجون إلى تخصيص العلامة التجارية دون إعادة بناء سلسلة التوريد بالكامل",
  solutionsBuyerCard3Need2: "يحتاجون إلى أنماط تغليف تتماشى مع تموضع العلامة التجارية",
  solutionsBuyerCard3Need3: "يحتاجون إلى تقصير المدة من العينة إلى الإطلاق",
  solutionsBuyerCard3Tag1: "تطبيق الشعار",
  solutionsBuyerCard3Tag2: "تغليف مخصص",
  solutionsBuyerCard3Tag3: "توسيع خط العلامة",
  solutionsBuyerCard4Title: "استوديوهات اليوغا",
  solutionsBuyerCard4Subtitle: "مجموعات الاستوديو والأدوات وحزم الصفوف.",
  solutionsBuyerCard4Need1: "يحتاجون إلى مجموعات بداية للأعضاء الجدد والصفوف التجريبية",
  solutionsBuyerCard4Need2: "يحتاجون إلى أدوات متينة مناسبة للجلسات عالية التكرار",
  solutionsBuyerCard4Need3: "يحتاجون إلى تسعير عملي للحزم لبرامج البيع الإضافي",
  solutionsBuyerCard4Tag1: "مجموعات بداية",
  solutionsBuyerCard4Tag2: "أدوات الصفوف",
  solutionsBuyerCard4Tag3: "حزم ترقية الأعضاء",
  solutionsBuyerCard5Title: "بائعو أمازون",
  solutionsBuyerCard5Subtitle: "حزم وتغليف جاهزان للأسواق الإلكترونية.",
  solutionsBuyerCard5Need1: "يحتاجون إلى هيكل حزم مدمج للتحكم في تكلفة الشحن",
  solutionsBuyerCard5Need2: "يحتاجون إلى تركيبات منتجات مناسبة للقوائم لتحسين التحويل",
  solutionsBuyerCard5Need3: "يحتاجون إلى جودة تغليف تقلل معدل الإرجاع",
  solutionsBuyerCard5Tag1: "حزم مدمجة",
  solutionsBuyerCard5Tag2: "تغليف جاهز للصور",
  solutionsBuyerCard5Tag3: "إطلاقات منخفضة الاحتكاك",
  solutionsBuyerCard6Title: "شركات التجارة الإلكترونية",
  solutionsBuyerCard6Subtitle: "منتجات بصرية أولًا لمبيعات إلكترونية متكررة.",
  solutionsBuyerCard6Need1: "يحتاجون إلى منتجات رئيسية تؤدي جيدًا في الإعلانات وحركة التواصل الاجتماعي",
  solutionsBuyerCard6Need2: "يحتاجون إلى حزم مرنة لرفع متوسط قيمة الطلب",
  solutionsBuyerCard6Need3: "يحتاجون إلى تحديث سريع للكتالوج للحملات الموسمية",
  solutionsBuyerCard6Tag1: "منتجات بطلة",
  solutionsBuyerCard6Tag2: "منطق الحزم",
  solutionsBuyerCard6Tag3: "تحديث سريع للكتالوج",
  solutionsScenario1Title: "مجموعات بداية الاستوديو",
  solutionsScenario1Body: "حزم يوغا جاهزة للإطلاق للصفوف والتجارب وباقات العضوية.",
  solutionsScenario2Title: "مناطق الاستشفاء والتدليك",
  solutionsScenario2Body: "أدوات تدليك ورولات وملحقات استشفاء لزوايا الصالات الرياضية.",
  solutionsScenario3Title: "برامج العرض بالتجزئة",
  solutionsScenario3Body: "تشكيلات متوازنة مع تغليف مناسب للعرض على الرفوف.",
  solutionsScenario4Title: "عروض الحزم عبر الإنترنت",
  solutionsScenario4Body: "مجموعات مدمجة مصممة لصفحات المنتجات الموجهة للتحويل.",
  solutionsProgram1Title: "تشكيلة إطلاق الاستوديو",
  solutionsProgram1Body: "تشكيلة بداية نظيفة لأعمال اليوغا القائمة على الصفوف.",
  solutionsProgram1Item1: "سجادات يوغا",
  solutionsProgram1Item2: "بلوكات وأحزمة",
  solutionsProgram1Item3: "إكسسوارات تدليك",
  solutionsProgram1SuitedFor: "الاستوديوهات / المدربون",
  solutionsProgram2Title: "برنامج رفوف التجزئة",
  solutionsProgram2Body: "عائلة منتجات متوازنة للمتاجر التي تحتاج إلى سلالم سعرية واضحة وطلبات متكررة.",
  solutionsProgram2Item1: "سجادات أساسية",
  solutionsProgram2Item2: "أدوات بيلاتس",
  solutionsProgram2Item3: "أدوات استشفاء سريعة الشراء",
  solutionsProgram2SuitedFor: "تجار التجزئة / الموزعون",
  solutionsProgram3Title: "حزمة للبيع عبر الإنترنت",
  solutionsProgram3Body: "مجموعات منتجات مدمجة مصممة لصور صفحات المنتج وتحويل أسهل عبر الإنترنت.",
  solutionsProgram3Item1: "مجموعات صغيرة",
  solutionsProgram3Item2: "عبوات مناسبة للهدايا",
  solutionsProgram3Item3: "إضافات للعلامة الخاصة",
  solutionsProgram3SuitedFor: "أمازون / التجارة الإلكترونية",
  contactResponseTitle: "متوسط زمن الاستجابة",
  contactResponseDesc: "خلال 8 ساعات عمل لطلبات عرض الأسعار القياسية.",
  carouselLoadingTitle: "جارٍ تحميل صور البانر",
  carouselLoadingBody: "نحن نجهّز لك العناصر البصرية للصفحة الرئيسية. يرجى الانتظار قليلًا حتى يتم تحميل صور البانر.",
  carouselPlaceholderTitle: "يتم تجهيز صور البانر",
  carouselPlaceholderBody: "سيظهر شريط الصفحة الرئيسية هنا بمجرد جاهزية موارد الصور.",
  aboutProductDev: "تطوير المنتجات",
  aboutProductDevDesc: "دورات عينات سريعة وتعاون تصميم عملي لتسريع الإطلاق إلى السوق.",
  aboutSupplyReliability: "موثوقية التوريد",
  aboutSupplyReliabilityDesc: "توريد مستقر للمواد وتخطيط للقدرات للحفاظ على سير التسليم خلال مواسم الذروة.",
  aboutTradeSupport: "دعم التسليم وما بعد البيع",
  aboutTradeSupportDesc: "المستندات، وتنسيق الشحن، ودعم ما بعد البيع لعمليات دولية أكثر سلاسة.",
  aboutSupplyList1: "تنسيق موردين موثوقين لخطوط اليوغا واللياقة الخفيفة",
  aboutSupplyList2: "مراجعة جودة متعددة المراحل مع مصانع الشركاء",
  aboutSupplyList3: "دعم العلامة الخاصة والتغليف",
  aboutSupplyList4: "دعم توريد عالمي عبر المناطق والقنوات الرئيسية",
  oemCapability1: "طباعة الشعارات المخصصة، والنقش، والوسم بالليزر للملحقات الأساسية لليوغا.",
  oemCapability2: "تعديلات اللون والمادة والملمس والحجم بما يتماشى مع السوق المستهدف.",
  oemCapability3: "تغليف جاهز للبيع بالتجزئة، وبطاقات إدراج، وملصقات باركود، وعلامات كراتين.",
  oemCapability4: "تطوير الحزم لمجموعات الاستوديو، وعبوات أمازون الجاهزة، والعروض الموسمية.",
  oemProcess1Title: "شارك فكرتك",
  oemProcess1Body: "أرسل المنتجات المستهدفة وملفات الشعار والصور المرجعية وتوقعات التغليف والكمية التقديرية.",
  oemProcess2Title: "تأكيد المواصفات والحد الأدنى للطلب",
  oemProcess2Body: "نراجع خيارات المواد وطريقة العلامة ونقاط الامتثال وزمن التوريد والكمية الابتدائية القابلة للتنفيذ.",
  oemProcess3Title: "العينة والمراجعة",
  oemProcess3Body: "نرتب العينات أو النماذج، ونجمع ملاحظاتك، ونثبت معيار الإنتاج قبل العربون.",
  oemProcess4Title: "الإنتاج الضخم والفحص",
  oemProcess4Body: "يسير الإنتاج وفق العينة المعتمدة، مع فحوص التغليف ومراجعة الجودة قبل الشحن.",
  news1Title: "إصدار دليل التوريد الربيعي",
  news1Body: "استكشف أحدث اتجاهات منتجات اليوغا والبيلاتس والاستشفاء لموسم البيع القادم.",
  news2Title: "تحديثات تغليف OEM",
  news2Body: "نحن الآن ندعم خيارات أكثر صداقة للبيئة للكرتون وبطاقات الإدراج والباركود لبرامج العلامة الخاصة.",
  news3Title: "إشعار جدول التصدير",
  news3Body: "يتم تحديث تخطيط زمن التوريد ونوافذ الشحن أسبوعيًا لمساعدة المشترين على إدارة جداول الإطلاق بدقة أكبر.",
  navYogaMats: "سجادات اليوغا",
  navYogaBlocks: "بلوكات اليوغا",
  navYogaStraps: "أحزمة اليوغا",
  navResistanceBands: "أشرطة المقاومة",
  navPilatesRings: "حلقات البيلاتس",
  navFoamRollers: "رولات الفوم",
  navOemPrivateLabel: "خدمة مخصصة",
  navSolutionsControl: "الحلول",
  navBlog: "المدونة",
  navCompanyProfile: "من نحن",
  navContactUs: "اتصل بنا",
  seeAllCategories: "عرض جميع الفئات",
  productDetailReady: "جاهز للعلامة الخاصة",
  productDetailQuote: "السعر عند الطلب",
  productDetailViewSpecs: "عرض المواصفات",
  productDetailRequestQuote: "طلب عرض سعر",
  pdLoadErrorProductDetail: "فشل تحميل تفاصيل المنتج",
  pdLoadErrorRelatedProducts: "فشل تحميل المنتجات ذات الصلة",
  pdLoadErrorStorefrontConfig: "فشل تحميل إعدادات المتجر",
  pdLoading: "جارٍ تحميل تفاصيل المنتج...",
  pdSampleDefaultMessage: "يرجى مشاركة سياسة العينة ومدة التسليم وتفاصيل عرض السعر.",
  pdAttrProductName: "اسم المنتج",
  pdAttrModelNo: "رقم الموديل",
  pdAttrCategory: "الفئة",
  pdAttrManufacturer: "المصنّع",
  pdLeadTimeOnRequest: "مدة التسليم عند الطلب",
  pdLeadTimeUpTo: "حتى {qty} قطعة: {days} يومًا",
  pdLeadTimeFrom: "{qty}+ قطعة: {days} يومًا",
  pdLeadTimeDaysOnly: "{days} يومًا",
  pdContactForQuote: "تواصل للحصول على عرض سعر",
  pdPerPiece: "{price} / قطعة",
  pdAnonymousBuyer: "مشتري مجهول",
  pdReviewTipSignIn: "يرجى تسجيل الدخول كعميل للتصويت على مدى الفائدة.",
  pdReviewTipSessionExpired: "انتهت الجلسة. يرجى تسجيل الدخول مرة أخرى للتصويت.",
  pdReviewTipNoPermission: "الحساب الحالي لا يملك صلاحية التصويت على الفائدة.",
  pdReviewTipUpdateFailed: "فشل تحديث حالة الفائدة",
  pdSpecValues: "القيم",
  pdSpecRequired: "مطلوب",
  pdSpecOptional: "اختياري",
  pdCapabilityCustomLogo: "تطبيق شعار مخصص",
  pdCapabilitySampleDev: "تطوير قائم على العينة",
  pdCapabilityPackagingCoordination: "تنسيق التعبئة",
  pdCapabilityExportFollowUp: "متابعة الشحن التصديري",
  pdPackagingSellingUnit: "وحدة البيع",
  pdPackagingSingleItem: "قطعة مفردة",
  pdPackagingType: "التعبئة",
  pdPackagingTypeFallback: "كيس OPP / كرتون تصدير",
  pdPackagingLoadingAdvice: "إرشادات التحميل",
  pdPackagingLoadingAdviceFallback: "حسب هيكل الطلب",
  pdPackagingLeadTime: "مدة التسليم",
  pdMediaPhotoLabel: "صورة {index}",
  pdMediaVideoLabel: "فيديو",
  pdMediaAttributesLabel: "الخصائص",
  pdPackagingPointPackaging: "التعبئة: {value}",
  pdPackagingPointLoadingAdvice: "إرشادات التحميل: {value}",
  pdPackagingPointShippingPort: "ميناء الشحن: {value} (قابل للتفاوض)",
  pdPackagingPointShippingPortNegotiable: "ميناء الشحن: قابل للتفاوض",
  pdPackagingPointLeadTime: "مدة التسليم: {value}",
  pdInquiryHello: "مرحبًا، أود الاستفسار عن:",
  pdInquiryProduct: "المنتج: {value}",
  pdInquirySku: "SKU: {value}",
  pdInquirySkuName: "اسم SKU: {value}",
  pdInquiryModel: "الموديل: {value}",
  pdInquiryQuantity: "الكمية: {value}",
  pdEmailSubject: "استفسار: {sku} - {name}",
  pdInquirySubmitFailed: "تعذر إرسال الاستفسار في الوقت الحالي.",
  pdSampleContactPerson: "جهة الاتصال: {value}",
  pdSampleWhatsapp: "WhatsApp/WeChat: {value}",
  pdSampleCompany: "الشركة: {value}",
  pdSampleRequestedQuantity: "الكمية المطلوبة: {value}",
  pdSampleSelectorQuantity: "محدد الكمية في الصفحة: {value}",
  pdVariationLabel: "الخيار",
  pdVariationInquiryIntro: "مرحبًا، أود إرسال استفسار عن:",
  pdVariationInquiryQuoteLeadTime: "يرجى مشاركة أحدث عرض سعر ومدة التسليم.",
  pdVideoFallback: "فشل تحميل الفيديو. يرجى المحاولة مجددًا أو فتح المصدر مباشرة.",
  pdRetry: "إعادة المحاولة",
  pdOpenVideoUrl: "فتح رابط الفيديو",
  pdProductAttributes: "خصائص المنتج",
  pdMediaTabsAria: "أنواع وسائط المنتج",
  pdMediaTabPhotos: "الصور",
  pdMediaTabVideo: "الفيديو",
  pdMediaTabAttributes: "الخصائص",
  pdInfoTabsAria: "تبويبات معلومات التفاصيل",
  pdInfoTabAttributes: "الخصائص",
  pdInfoTabDescription: "الوصف",
  pdInfoTabSupplier: "المورّد",
  pdInfoTabReviews: "التقييمات",
  pdKeyAttributes: "الخصائص الأساسية",
  pdPackagingShippingInfo: "معلومات التعبئة والشحن",
  pdProductDescription: "وصف المنتج",
  pdSupplierOverview: "نظرة عامة على المورّد",
  pdSupplierOverviewHint: "يتم عرض ملف الشركة والأسئلة الشائعة أسفل صور التفاصيل.",
  pdBuyerFeedback: "آراء المشترين",
  pdRepeatBuyer: "مشتري متكرر",
  pdReviewRatingAria: "التقييم {rating} من 5",
  pdReviewMetaColor: "اللون: {value}",
  pdReviewMetaColorFallback: "الثاني",
  pdReviewUnavailable: "هذا المنتج لم يعد متاحًا",
  pdReviewHelpful: "مفيد ({count})",
  pdNoReviews: "لا توجد تقييمات لهذا المنتج حتى الآن.",
  pdNoReviewsHint: "تواصل مع فريقنا للحصول على مراجع طلبات أو ملاحظات عينات.",
  pdTitleFallback: "تفاصيل المنتج",
  pdCustomizable: "قابل للتخصيص",
  pdVariationCardAria: "خيارات المنتج",
  pdVariations: "الخيارات",
  pdSelectNow: "اختر الآن",
  pdSelectOption: "اختر خيارًا",
  pdLadderPricingAria: "تسعير تدريجي",
  pdProductSpecifications: "مواصفات المنتج",
  pdSpecPrevAria: "عرض قيمة المواصفة السابقة",
  pdSpecNextAria: "عرض قيمة المواصفة التالية",
  pdSupplierCapability: "قدرة المورّد على التخصيص",
  pdGetFreeSample: "احصل على عينة مجانية",
  pdWhatsAppInquiry: "استفسار عبر WhatsApp",
  pdEmailInquiry: "استفسار عبر البريد",
  pdPackagingDelivery: "التعبئة والتسليم",
  pdProductVideo: "فيديو المنتج",
  pdVideoOpenLink: "لا يمكن تشغيل الفيديو في السياق الحالي.",
  pdSupplierDescriptions: "وصف المنتج من المورّد",
  pdCompanyIntroduction: "مقدمة الشركة",
  pdNoCompanyIntroduction: "لا توجد مقدمة شركة مهيأة.",
  pdFaq: "الأسئلة الشائعة",
  pdNoFaq: "لا توجد أسئلة شائعة مهيأة.",
  pdCloseVariationSelector: "إغلاق محدد الخيارات",
  pdVariationSelectAndQty: "اختر الخيارات والكمية",
  pdVariationStock: " / المخزون {count}",
  pdSelectedQuantity: "الكمية المحددة",
  pdSendInquiry: "إرسال استفسار",
  pdChatNow: "تحدث الآن",
  pdOptionLabel: "الخيار {index}",
  pdRelatedAria: "منتجات ذات صلة",
  pdRelatedTitle: "منتجات ذات صلة",
  pdRelatedSubtitle: "المزيد من المنتجات التي يطلبها المشترون معًا ضمن هذه الفئة.",
  pdRelatedPrevAria: "المنتجات ذات الصلة السابقة",
  pdRelatedNextAria: "المنتجات ذات الصلة التالية",
  pdSampleContactTitle: "يرجى التواصل معنا",
  pdSampleContactDesc: "هل لديك أسئلة؟ يسعدنا مساعدتك. تواصل معنا عبر WhatsApp أو البريد لدعم العينات.",
  pdSampleCloseAria: "إغلاق استفسار العينة",
  pdSampleSummaryProduct: "المنتج",
  pdSampleSummaryQuantity: "الكمية",
  pdFormFullName: "الاسم الكامل",
  pdFormFullNamePlaceholder: "اسمك",
  pdFormEmail: "البريد الإلكتروني*",
  pdFormEmailPlaceholder: "للتواصل معك عبر البريد الإلكتروني",
  pdFormWhatsapp: "WhatsApp/WeChat*",
  pdFormWhatsappPlaceholder: "للتواصل معك عبر WhatsApp",
  pdFormCompany: "اسم شركتك",
  pdFormCompanyPlaceholder: "اسم شركتك",
  pdFormRequiredQuantity: "الكمية المطلوبة",
  pdFormRequiredQuantityPlaceholder: "الكمية المطلوبة للعينة أو التجربة",
  pdFormMessage: "الرسالة",
  pdFormMessagePlaceholder: "يرجى وصف متطلبات منتجك بإيجاز",
  pdFormSending: "جارٍ الإرسال...",
  pdFormSendMessage: "إرسال الرسالة",
  pdFormInquirySuccess: "تم إرسال الاستفسار بنجاح.",
  oemHeroKicker: "خدمة مخصصة",
  oemTitle: "أنشئ خط يوغا مخصصًا بسير إنتاج واضح",
  oemIntro: "ندعم المشترين الدوليين في تخصيص المنتجات وتطوير التغليف ومتابعة العينات وتنفيذ الطلبات لفئات اليوغا واللياقة الخفيفة.",
  oemStartProject: "ابدأ مشروعك المخصص",
  oemBrowseProducts: "تصفح المنتجات الأساسية",
  oemVisualGuide: "دليل بصري للتخصيص",
  oemVisualAlt: "خيارات تخصيص OEM ودليل العملية",
  oemVisualPlaceholder: "لم يتم العثور على صورة التخصيص. أضف مرفقك إلى frontend/public/assets/about/oem-customization-guide.jpg",
  oemCapabilityKicker: "ما الذي يمكننا تخصيصه",
  oemCapabilityTitle: "من تطبيق الشعار إلى تنفيذ التغليف الكامل",
  oemProjectBrief: "ملخص المشروع",
  oemServiceShowcaseAria: "خدمات تخصيص OEM وODM",
  oemServiceShowcaseTitle: "خدمات تخصيص OEM وODM",
  oemServiceShowcaseBody: "دعم مرن متكامل من مراجعة الفكرة إلى الإنتاج وتسليم الشحنة.",
  oemCompareHeadBody: "أربعة مسارات شائعة، معروضة كمنتج أساسي مقابل نتيجة مخصصة.",
  oemCompareBaseSuffix: "النسخة الأساسية",
  oemCompareOptionsSuffix: "خيارات التخصيص",
  oemCompareCustomizedSuffix: "النسخة المخصصة",
  oemCompare1Title: "تطبيق الشعار",
  oemCompare1Body: "منتج بسيط إلى عرض بعلامة تجارية.",
  oemCompare1BeforeLabel: "أساسي",
  oemCompare1AfterLabel: "مع الشعار",
  oemCompare1CustomizationLabel: "إضافة الشعار",
  oemCompare1Item1: "طباعة",
  oemCompare1Item2: "نقش",
  oemCompare1Item3: "وسم ليزري",
  oemCompare2Title: "اللون والإنهاء",
  oemCompare2Body: "مواصفة حيادية إلى لون مناسب للسوق.",
  oemCompare2BeforeLabel: "قياسي",
  oemCompare2AfterLabel: "لون مخصص",
  oemCompare2CustomizationLabel: "تحديث اللون",
  oemCompare2Item1: "اللون",
  oemCompare2Item2: "الملمس",
  oemCompare2Item3: "الحجم",
  oemCompare3Title: "إعداد التغليف",
  oemCompare3Body: "عبوة بسيطة إلى عرض جاهز للبيع بالتجزئة.",
  oemCompare3BeforeLabel: "عبوة بسيطة",
  oemCompare3AfterLabel: "جاهز للتجزئة",
  oemCompare3CustomizationLabel: "تفاصيل التغليف",
  oemCompare3Item1: "بطاقة إدراج",
  oemCompare3Item2: "باركود",
  oemCompare3Item3: "علامة الكرتون",
  oemCompare4Title: "تطوير الحزم",
  oemCompare4Body: "عناصر فردية إلى مجموعة جاهزة للقناة.",
  oemCompare4BeforeLabel: "عناصر مفردة",
  oemCompare4AfterLabel: "مجموعة حزمة",
  oemCompare4CustomizationLabel: "منطق الحزمة",
  oemCompare4Item1: "مجموعة استوديو",
  oemCompare4Item2: "عبوة أمازون",
  oemCompare4Item3: "مزيج ترويجي",
  oemCasesTitle: "حالات تخصيص",
  oemCase1Title: "خط بداية لاستوديو بوتيكي",
  oemCase1Summary: "عرض مجموعة بداية لإطلاق استوديو بوتيكي.",
  oemCase1Details: "تم اعتماد حزمة جاهزة بالشعار خلال 12 يومًا.",
  oemCase2Title: "تحديث علامة خاصة للتجزئة",
  oemCase2Summary: "مظهر تغليف محدث لعرض أكثر نظافة على الرف.",
  oemCase2Details: "اعتماد أسرع من المشتري واتساق أقوى في البيع بالتجزئة.",
  oemCase3Title: "حزمة لياقة جاهزة للسوق الإلكتروني",
  oemCase3Summary: "إعداد حزمة مهيأ للتجارة الإلكترونية والاستخدام في القوائم.",
  oemCase3Details: "جاهزة مع البطاقة والباركود ومراجعة الإنتاج الكمي.",
  oemOrderingFlowKicker: "مسار الطلب",
  oemOrderingFlowTitle: "التواصل والطلب في خمس خطوات",
  oemContactFlow1: "استفسار أولي مع قائمة المنتجات وسوق الوجهة وطلب العلامة التجارية.",
  oemContactFlow2: "عرض سعر مع خطة عينة ومدة توريد وخيارات التغليف.",
  oemContactFlow3: "تأكيد العينة واعتماد تفاصيل الطلب.",
  oemContactFlow4: "العربون والإنتاج والفحص وحجز الشحنة.",
  oemContactFlow5: "سداد الرصيد ومستندات التصدير ومتابعة ما بعد البيع.",
  oemContactSideTitle: "هل أنت جاهز لمناقشة طلب OEM الخاص بك؟",
  oemContactSideBody: "أرسل شعارك وهدف الكمية وفكرة التغليف. وسنرد عليك بمسار عرض سعر عملي وتوصية مناسبة للعينة.",
  oemContactSideNote: "طريقة التواصل المفضلة أولًا: البريد الإلكتروني أو نموذج الاستفسار مع ملف التصميم ونافذة الشحن المستهدفة.",
  oemContactSideCta: "تواصل مع فريق المبيعات",
  newsHeroKicker: "تحديثات الصناعة",
  newsTitle: "الأخبار والتحديثات",
  newsIntro: "تابع أحدث رؤانا في التوريد وملاحظات إطلاق المنتجات وتحديثات التصدير لمشتري إكسسوارات اللياقة.",
  newsSectionTitle: "لإعلانات المشاريع المخصصة أو معاينات التشكيلات الجديدة، تواصل مع فريق المبيعات للحصول على أحدث كتالوج.",
  contactTitle: "اتصل بالمورّد",
  contactHeroKicker: "استفسار تجاري",
  contactIntro: "أخبرنا بمتطلبات منتجك وسوقك المستهدف. سيرد فريقنا بتفاصيل عرض السعر وتقديرات مدة التوريد.",
  contactFormTitle: "إرسال استفسار",
  contactName: "اسمك",
  contactEmail: "البريد الإلكتروني للعمل",
  contactCompany: "اسم الشركة",
  contactMessage: "مواصفات المنتج، الكمية، وجهة الشحن",
  contactSubmit: "إرسال استفسار",
  contactSent: "تم إرسال الرسالة بنجاح.",
  contactInfoTitle: "مكتب المبيعات",
  contactInfoEmail: "البريد الإلكتروني",
  contactInfoPhone: "الهاتف",
  contactInfoHours: "ساعات العمل: الإثنين-السبت، 09:00-18:00 (GMT+8)",
  contactInfoNote: "القنوات المفضلة: البريد الإلكتروني لعروض الأسعار الرسمية، والهاتف لتأكيد جداول الطلبات العاجلة.",
  contactInquiryGreeting: "مرحبًا، أود الاستفسار عن هذا المنتج:",
  contactInquiryProductPrefix: "المنتج:",
  contactInquiryQuantity: "الكمية:",
  contactInquiryDestinationPort: "ميناء الوجهة:",
  aboutTitle: "حول LOYA SPORT",
  aboutIntro: "LOYA SPORT هي مُكامل سلسلة توريد لمنتجات اليوغا يخدم المشترين العالميين في قطاع B2B.",
  aboutWhoWeAre: "من نحن",
  aboutWhoWeAreDesc1: "ندعم المستوردين والموزعين وتجار التجزئة وعلامات العلامة الخاصة من خلال تنسيق التوريد والعينات والعلامة التجارية ومتابعة الشحن مع شركاء توريد موثوقين.",
  aboutWhoWeAreDesc2: "تكمن قوتنا في التواصل العملي والتركيز الفئوي وسير شراء واضح يساعد العملاء الدوليين على التحرك بسرعة أكبر.",
  aboutSupplyCapabilities: "قدرات التوريد",
  aboutMission: "مهمتنا",
  aboutMissionDesc: "مساعدة علامات اللياقة ومشتري التجزئة على النمو من خلال توريد موثوق، وضبط جودة صارم، ودعم كامل لما بعد البيع.",
  navHome: "الرئيسية",
  navProducts: "المنتجات",
  navCustomization: "خدمة مخصصة",
  navSolutions: "الحلول",
  navAbout: "من نحن",
  navContact: "اتصل بنا",
  btnContactUs: "اتصل بنا",
  btnLogin: "تسجيل الدخول",
  btnAccount: "الحساب",
  btnQuote: "طلب عرض سعر",
  btnCurrency: "العملة",
  btnLanguage: "اللغة",
  requestQuote: "طلب عرض سعر",
  trustTitle: "الشركاء العالميون والثقة",
  factoryStatsSize: "مصنع بمساحة 30,000 متر مربع",
  factoryStatsQC: "فحص جودة كامل أثناء الإنتاج وبعده بنسبة 100%",
  homeAriaTrust: "قسم الثقة والشركاء",
  homeAriaStats: "إحصاءات وبيانات المصنع",
  authLogin: {
    welcomeBack: "مرحبًا بعودتك",
    brandIntro: "سجّل الدخول لمواصلة توريد منتجات اليوغا واللياقة.",
    brandBullet1: "سير عمل RFQ سريع",
    brandBullet2: "متابعة المنتجات والطلبات",
    brandBullet3: "دعم حسابات B2B",
    accountLogin: "تسجيل الدخول إلى الحساب",
    createAccount: "إنشاء حساب",
    recoverPassword: "استعادة كلمة المرور",
    registrationComplete: "اكتمل التسجيل",
    passwordUpdated: "تم تحديث كلمة المرور",
    loginDesc: "استخدم اسم المستخدم أو البريد الإلكتروني وكلمة المرور للمتابعة.",
    registerDesc: "أنشئ حسابك عبر اسم المستخدم والتحقق بالبريد وكود التحقق.",
    forgotDesc: "أدخل بريد حسابك للحصول على رمز إعادة التعيين.",
    registerSuccessDesc: "تم إنشاء حسابك بنجاح. سنعود تلقائيًا إلى شاشة تسجيل الدخول.",
    resetSuccessDesc: "تم تحديث كلمة المرور بنجاح. سنعود تلقائيًا إلى شاشة تسجيل الدخول.",
    redirectHintPrefix: "سيتم تحويل الصفحة إلى شاشة تسجيل الدخول خلال",
    redirectHintSuffix: ".",
    seconds: "ثوانٍ",
    loginNow: "تسجيل الدخول الآن",
    username: "اسم المستخدم",
    usernamePlaceholder: "3 أحرف على الأقل، مثال: loya_buyer",
    usernameHelp: "يجب أن يكون اسم المستخدم 3 أحرف على الأقل، وألا يستخدم كلمات محجوزة، ويقتصر على الحروف والأرقام والشرطة السفلية والشرطة العادية.",
    usernameExistsHint: "اسم المستخدم هذا مسجل بالفعل. سجّل الدخول مباشرة أو اختر اسمًا آخر.",
    usernameExists: "اسم المستخدم موجود بالفعل. اختر اسمًا آخر أو سجّل الدخول مباشرة.",
    usernameExistsAction: "اسم المستخدم موجود، الانتقال لتسجيل الدخول",
    usernameAlreadyRegistered: "اسم المستخدم هذا مسجل بالفعل.",
    usernameAvailable: "اسم المستخدم متاح.",
    usernameVerifyFailed: "تعذر التحقق من اسم المستخدم الآن. يرجى المحاولة مرة أخرى.",
    checkingUsername: "جارٍ التحقق من توفر اسم المستخدم...",
    email: "البريد الإلكتروني",
    emailPlaceholder: "your@email.com",
    emailCodeTargetHint: "أدخل البريد الإلكتروني الذي تريد استخدامه لاستلام رمز التحقق.",
    emailExistsHint: "هذا البريد الإلكتروني مسجل بالفعل. سجّل الدخول مباشرة أو استخدم بريدًا آخر.",
    emailExists: "البريد الإلكتروني موجود بالفعل. استخدم بريدًا آخر أو انتقل لتسجيل الدخول.",
    emailExistsAction: "البريد موجود، الانتقال لتسجيل الدخول",
    emailAlreadyRegistered: "هذا البريد الإلكتروني مسجل بالفعل.",
    emailAvailable: "البريد الإلكتروني متاح.",
    emailVerifyFailed: "تعذر التحقق من البريد الإلكتروني الآن. يرجى المحاولة مرة أخرى.",
    checkingEmail: "جارٍ التحقق من توفر البريد الإلكتروني...",
    usernameOrEmail: "اسم المستخدم أو البريد",
    usernameOrEmailPlaceholder: "اسم المستخدم أو your@email.com",
    forgotEmailHint: "أدخل البريد الإلكتروني المرتبط بحسابك لكي نرسل رمز إعادة التعيين.",
    password: "كلمة المرور",
    passwordPlaceholder: "أدخل كلمة المرور",
    confirmPassword: "تأكيد كلمة المرور",
    confirmPasswordPlaceholder: "أعد إدخال كلمة المرور",
    confirmNewPassword: "تأكيد كلمة المرور الجديدة",
    confirmNewPasswordPlaceholder: "أعد إدخال كلمة المرور الجديدة",
    nickname: "الاسم المستعار",
    nicknamePlaceholder: "اختياري، للاستخدام في العرض",
    captcha: "كود التحقق",
    registerCaptcha: "كود تحقق التسجيل",
    resetCaptcha: "كود تحقق إعادة التعيين",
    refreshCaptcha: "تحديث كود التحقق",
    load: "تحميل",
    forgotCaptchaHint: "أكمل كود التحقق أولًا ثم اطلب رمز إعادة تعيين كلمة المرور. بعد إرسال الرمز سيتم تحميل كود جديد تلقائيًا للخطوة النهائية.",
    registerCaptchaHint: "أكمل كود التحقق أولًا ثم اطلب رمز التحقق عبر البريد الإلكتروني.",
    registerStepHint: "املأ اسم المستخدم وكلمة المرور وتأكيدها وبريدًا إلكترونيًا صالحًا أولًا. بعد ذلك سيظهر قسم كود التحقق ورمز البريد.",
    emailCode: "رمز البريد الإلكتروني",
    emailCodePlaceholder: "رمز من 6 أرقام",
    resetCode: "رمز إعادة التعيين",
    resetCodePlaceholder: "رمز إعادة تعيين من 6 أرقام",
    sending: "جارٍ الإرسال...",
    resendIn: "إعادة الإرسال خلال",
    sendEmailCode: "إرسال رمز البريد",
    sendResetCode: "إرسال رمز إعادة التعيين",
    signingIn: "جارٍ تسجيل الدخول...",
    login: "تسجيل الدخول",
    updating: "جارٍ التحديث...",
    creating: "جارٍ الإنشاء...",
    resetPassword: "إعادة تعيين كلمة المرور",
    forgotRequirementHint: "استعادة كلمة المرور تتطلب التحقق بكود captcha ورمز إعادة التعيين المرسل إلى بريدك.",
    registerRequirementHint: "يتطلب التسجيل رمز البريد الإلكتروني المرسل إلى صندوق الوارد.",
    captchaRefreshHint: "إذا كان كود التحقق غير واضح، انقر على الصورة اليمنى لتحديثه.",
    switchToLogin: "لديك حساب بالفعل؟ سجّل الدخول الآن",
    switchToRegister: "لا يوجد حساب بعد؟ أنشئ حسابًا الآن",
    backToLogin: "العودة إلى تسجيل الدخول",
    forgotPassword: "هل نسيت كلمة المرور؟",
    usernameRequired: "أدخل اسم مستخدم لا يقل عن 3 أحرف.",
    usernameMin: "يجب أن يكون اسم المستخدم 3 أحرف على الأقل.",
    usernameMax: "يجب ألا يتجاوز اسم المستخدم 24 حرفًا.",
    usernamePattern: "يمكن أن يحتوي اسم المستخدم على حروف وأرقام وشرطة سفلية وشرطة عادية فقط.",
    usernameReserved: "اسم المستخدم هذا محجوز. يرجى اختيار اسم آخر.",
    usernameFormatOk: "تنسيق اسم المستخدم صحيح.",
    emailRequired: "أدخل عنوان بريد إلكتروني.",
    emailInvalid: "أدخل عنوان بريد إلكتروني صالحًا.",
    emailFormatOk: "تنسيق البريد الإلكتروني صحيح.",
    emailProviderHint: "يفضل استخدام مزود بريد شائع مثل Gmail أو Outlook أو QQ Mail أو 163 أو 126 أو Foxmail.",
    passwordRequired: "أدخل كلمة المرور.",
    didYouMean: "هل تقصد",
    passwordMin: "يجب أن تتكون كلمة المرور من 6 أحرف على الأقل.",
    newPasswordMin: "يجب أن تتكون كلمة المرور الجديدة من 6 أحرف على الأقل.",
    confirmPasswordRequired: "أدخل تأكيد كلمة المرور.",
    passwordMatch: "كلمتا المرور متطابقتان.",
    passwordMismatch: "كلمتا المرور غير متطابقتين.",
    emailCodeRequired: "أدخل رمز التحقق عبر البريد الإلكتروني.",
    resetCodeRequired: "أدخل رمز إعادة التعيين المرسل إلى بريدك.",
    captchaRequired: "أدخل كود التحقق.",
    captchaExpired: "انتهت صلاحية رمز التحقق. يرجى تحديث الصفحة والمحاولة مجددًا.",
    captchaIncorrect: "رمز التحقق غير صحيح. يرجى المحاولة مجددًا.",
    registerPrerequisitesError: "أكمل اسم المستخدم وكلمة المرور وتأكيدها وبريدًا صالحًا قبل طلب رمز التحقق عبر البريد.",
    enterCaptchaBeforeEmailCode: "أدخل كود التحقق قبل طلب رمز التحقق عبر البريد.",
    enterCaptchaBeforeResetCode: "أدخل كود التحقق قبل طلب رمز إعادة تعيين كلمة المرور.",
    sendEmailCodeFailed: "فشل إرسال رمز التحقق عبر البريد الإلكتروني.",
    emailCodeSent: "تم إرسال رمز التحقق عبر البريد الإلكتروني.",
    emailCodeSentInbox: "تم إرسال رمز التحقق عبر البريد الإلكتروني. يرجى التحقق من صندوق الوارد.",
    previewCodeCurrentEnv: "رمز المعاينة للبيئة الحالية",
    previewCodeDevelopment: "رمز المعاينة للتطوير",
    previewCodeGenerated: "تم إنشاء رمز التحقق. تستخدم هذه البيئة رمز معاينة.",
    previewCodeContinueRegistration: "أدخل هذا الرمز المكوّن من 6 أرقام لإكمال التسجيل.",
    tooManyRequests: "طلبات كثيرة جدًا. يرجى المحاولة مرة أخرى لاحقًا.",
    smtpConfigRetry: "فشل إرسال البريد الإلكتروني. تحقق من إعدادات SMTP وأعد المحاولة.",
    emailServiceNotConfigured: "خدمة البريد الإلكتروني غير مُعدَّة. يرجى التواصل مع المسؤول.",
    requestFailed: "فشل الطلب. يرجى المحاولة مرة أخرى أو التواصل مع الدعم.",
    registerFailed: "فشل التسجيل",
    resetFailed: "فشل إعادة تعيين كلمة المرور",
    loginFailed: "فشل تسجيل الدخول",
    registerSuccessNotice: "تم التسجيل بنجاح. سيتم التحويل إلى شاشة تسجيل الدخول خلال حوالي 4 ثوانٍ.",
    resetSuccessNotice: "تمت إعادة تعيين كلمة المرور بنجاح. سيتم التحويل إلى شاشة تسجيل الدخول خلال حوالي 1.5 ثانية.",
    loginTokenMissing: "رمز تسجيل الدخول مفقود",
    profileLoadFailed: "فشل تحميل ملف الحساب الشخصي",
    loginSuccessAdmin: "تم تسجيل الدخول بنجاح. جارٍ التحويل...",
    loginSuccessStorefront: "تم تسجيل الدخول بنجاح. جارٍ التحويل إلى المتجر...",
    loginServiceUnavailable: "خدمة تسجيل الدخول غير متاحة مؤقتًا. يرجى المحاولة بعد قليل.",
    accountNotFound: "الحساب غير موجود. يرجى التحقق من اسم المستخدم أو البريد الإلكتروني.",
    passwordIncorrect: "كلمة المرور غير صحيحة. يرجى المحاولة مجددًا.",
    registrationNotOpen: "تسجيل الدخول والتسجيل مغلقان حاليًا.",
    accountRestricted: "تم تقييد هذا الحساب. يرجى التواصل مع المسؤول.",
    orContinueWith: "أو تابع باستخدام",
    googleAuthorizing: "جارٍ تفويض حساب Google...",
    googleFallbackAction: "تابع باستخدام Google",
    googleAuthFailed: "فشل مصادقة Google",
    googleAuthOffline: "تسجيل الدخول عبر Google غير متوفر مؤقتًا بدون اتصال. يرجى الاتصال بالإنترنت أو استخدام اسم المستخدم وكلمة المرور.",
    googleAuthTimeout: "انتهت مهلة التحقق من Google. يرجى إعادة المحاولة قريبًا. إذا استمرت المشكلة، اطلب من المسؤول التحقق من وصول شبكة الخادم للخارج.",
    googleAuthNetworkError: "فشل التحقق من Google بسبب خطأ في شبكة الخادم. يرجى التواصل مع المسؤول.",
    googleRegisterSuccess: "تم ربط حساب Google بنجاح. جارٍ التوجيه إلى المتجر...",
    googleCreateAccountTitle: "أكمل التسجيل عبر Google",
    googleCreateAccountDesc: "تحقق Google من بريدك الإلكتروني. عيّن كلمة مرور لإنشاء حساب عميل وإتمام تسجيل الدخول.",
    googleCreateAccountHint: "لا يوجد حساب لهذا البريد الخاص بـ Google بعد. عيّن كلمة مرور لإنشاء حساب عميل.",
    googleLinkedEmailHint: "سيُستخدم هذا البريد الإلكتروني المتحقق منه عبر Google لإنشاء حساب العميل.",
    googleCreatePasswordHint: "عيّن كلمة مرور وأكدها. سيستخدم الحساب الجديد للعميل بريدك الإلكتروني المتحقق منه عبر Google.",
    submitLogin: "تسجيل الدخول",
    submitRegister: "إنشاء الحساب",
    submitReset: "إعادة تعيين كلمة المرور"
  },
  admin: {
    productCategoryYogaMats: "سجادات اليوغا",
    productCategoryYogaBlocks: "بلوكات اليوغا",
    productCategoryYogaStraps: "أحزمة اليوغا",
    productCategoryResistanceBands: "أشرطة المقاومة",
    productCategoryPilatesRings: "حلقات البيلاتس",
    productCategoryFoamRollers: "رولات الفوم",
    productCategoryOthers: "أخرى",
    faqSampleOrderQ: "هل تقبلون طلبات العينات؟",
    faqSampleOrderA: "نعم، نقبل طلبات العينات، لا تتردد في التواصل معنا.",
    faqCustomPackagingQ: "هل تقدمون خدمة التغليف المخصص والشعار؟",
    faqCustomPackagingA: "نعم، نقدم خدمات OEM/ODM مخصصة.",
    faqLeadTimeQ: "ما هي مدة التسليم لديكم؟",
    faqLeadTimeA: "عادةً من 1 إلى 3 أيام بحسب كمية الطلب، ويتم تأكيد مدة التسليم النهائية عند تقديم الطلب.",
    faqDefectiveItemQ: "كيف يتم التعامل مع المنتج المعيب؟",
    faqDefectiveItemA: "نقدم ضمانًا لمدة سنة واحدة يبدأ من تاريخ الشحن. خلال فترة الضمان، إذا كان لديك منتج معيب بسبب المواد أو التصنيع لدينا، يرجى تزويدنا بالتفاصيل بما في ذلك الوصف والصور أو الفيديو، وحتى عينة معيبة عند الحاجة، وسيقوم مهندسونا بالتحليل وتقديم الحل. إذا رغبت في الإرجاع، يرجى التواصل معنا وإعادة المنتجات مع تغليفها الأصلي وملحقاتها، وسيتم رد المبلغ عند استلام المنتجات المرتجعة أو إرسال بديل مجاني.",
    faqWhyChooseUsQ: "لماذا تختارنا؟",
    faqWhyChooseUsA: "منتجاتنا تتميز بحد أدنى منخفض للطلب وجودة عالية تلبي معايير الولايات المتحدة أو الاتحاد الأوروبي. نحن نقدم خدمة عالية المستوى، ونقبل طلبات OEM وTrade Assurance. يمكنك الشحن بثقة.",
    companyImageSectionOverview: "نظرة عامة على الشركة",
    companyImageSectionAdvantages: "المزايا التنافسية",
    companyImageSectionCustomization: "قدرات التخصيص",
    companyImageSectionExtended: "ملف الشركة الموسع",
    companyImageSectionPackaging: "مواصفات التعبئة والشحن",
    companyImageSectionFactory: "ملف المصنع",
    companyImageSectionWorkflow: "سير عمل الإنتاج",
    companyImageSectionTradeShow: "المشاركة في المعارض",
    orderStatusPaid: "مدفوع",
    orderStatusPacked: "تم التعبئة",
    orderStatusInTransit: "قيد النقل",
    orderStatusDelivered: "تم التسليم",
    orderStatusCancelled: "ملغي",
    tabDescHome: "قم بإدارة عمليات مساحة العمل ومراقبة الأداء هنا.",
    tabDescStoreBase: "قم بتكوين عناوين الواجهة الأمامية/لوحة الإدارة وبيانات SEO الوصفية.",
    tabDescTemplateStudio: "قم بتحرير وحدات تخطيط المتجر بشكل مرئي وحفظ القوالب المخصصة.",
    tabDescArticleManagement: "إدارة مقالات المدونة في مساحة عمل مخصصة مع تحرير قائم على النوافذ.",
    tabDescCompanyImages: "إدارة فئات صور الشركة المستخدمة في محتوى ملف المتجر.",
    tabDescDesignNav: "تكوين تنقل الواجهة الأمامية وهياكل القوائم المتداخلة.",
    tabDescDesignCarousel: "إدارة بانرات شريط الصفحة الرئيسية في الواجهة الأمامية.",
    tabDescDesignBanner: "تكوين رسائل البانر ومحتوى الدعوة لاتخاذ إجراء.",
    tabDescFaqKnowledge: "الحفاظ على قاعدة معرفة للأسئلة الشائعة تستخدمها فرق التشغيل والمبيعات.",
    tabDescProducts: "إدارة كتالوج المنتجات والتفاصيل ومعلومات التسعير.",
    tabDescProductCreate: "إنشاء منتجات جديدة واستكمال جميع المعلومات والوسائط.",
    tabDescMerchandising: "تقييم المنتجات المرشحة، وهياكل التسعير، وجاهزية الإطلاق.",
    tabDescProcurement: "تنسيق خطط الشراء، وتقدم الموردين، وأولوية التوريد.",
    tabDescQuality: "تتبع نقاط فحص الجودة وجاهزية الإفراج قبل التنفيذ.",
    tabDescLogistics: "متابعة حالة الشحن، وتجهيز التعبئة، وتنسيق اللوجستيات.",
    tabDescOrders: "تتبع دورة حياة الطلب بالكامل، والتنفيذ، وتحديثات الشحن.",
    tabDescCustomers: "إدارة أعضاء الفريق وصلاحيات حساباتهم هنا.",
    tabDescMarketing: "عرض حالة الحملات التسويقية وأداء النمو.",
    tabDescDiscounts: "إدارة استراتيجيات التسعير وقواعد العروض.",
    tabDescFinance: "مراقبة السجلات المالية واتجاهات الإيرادات.",
    tabDescFinanceIncome: "راجع تحصيلات الطلبات والإيرادات المعترف بها وسجلات دفتر الإيرادات.",
    tabDescFinanceExpenses: "تتبع فواتير المشتريات والخدمات اللوجستية والتسويق ومصاريف المكتب.",
    tabDescFinanceReceivables: "تتبع المستحقات والتقادم وأولويات التحصيل.",
    tabDescFinancePayables: "إدارة المدفوعات ومدفوعات الموردين وضغط تواريخ الاستحقاق.",
    tabDescFinanceInvoices: "الحفاظ على الفواتير والإيصالات وحالة الفوترة.",
    tabDescFinanceTax: "مراجعة ضريبة المخرجات وضريبة المدخلات وتقديرات الضريبة.",
    tabDescFinanceBudget: "تتبع الميزانيات وتخصيص النفقات وتنبيهات الإنفاق الزائد.",
    tabDescFinanceDaily: "ملخص دخل الشركة ونفقاتها وصافي النقد يوميًا.",
    tabDescFinanceMonthly: "إغلاق الدفاتر الشهرية ومراجعة الأرباح وفرق الميزانية.",
    tabDescFinanceYearly: "مراجعة الإيرادات السنوية والنفقات والضرائب وصافي الأرباح.",
    tabDescFinanceReconciliation: "تسوية المستحقات والتحصيلات والمدفوعات والفواتير وحالة الضريبة.",
    tabDescFinanceApprovals: "معالجة مراجعات اعتماد المبالغ المستردة والمدفوعات والنفقات.",
    tabDescFinanceReports: "ملخص البيانات المالية والمقاييس التشغيلية ومهام التصدير.",
    tabDescAnalytics: "تحليل الرؤى البيانية ومؤشرات التشغيل.",
    tabDescSettings: "إدارة الإعدادات الأساسية للنظام مثل اتصالات قاعدة البيانات.",
    tabDescWorkTargets: "تتبع أهداف المهام اليومية وتنسيقها.",
    tabDescWorkProcessing: "معالجة سير العمل المخصص وسجلات التنفيذ.",
    tabDescHrEmployee: "عرض وصيانة ملفات الموظفين ومعلومات الحساب.",
    tabDescHrRecruitment: "تتبع الانضمام وطوابير المهام المتعلقة بالتوظيف.",
    tabDescHrAttendance: "مراقبة حضور الموظفين وحالة نشاط الحساب.",
    tabDescHrOffice: "إدارة تغطية المناصب والمهام الإدارية الداخلية.",
    tabDescSiteMaintenance: "صيانة محتوى الواجهة الأمامية واستقرار الموقع.",
    tabDescPermissionMaintenance: "صيانة الصلاحيات المعتمدة على الأدوار وحدود الوصول.",
    tabDescPositionMaintenance: "صيانة هياكل المناصب وربط المستخدمين.",
    tabDescProfile: "عرض معلومات حسابك.",
    tabDescPassword: "تغيير كلمة مرور الحساب بأمان.",
    tabDescInquiry: "التواصل مع البائعين ومتابعة مناقشات الاستفسارات.",
    tabDescWishlist: "إدارة المنتجات المحفوظة والاختيارات المفضلة.",
    tabDescOrderProcessing: "تتبع ومعالجة سجلات الطلبات طوال دورة الحياة.",
    tabDescAfterSales: "متابعة طلبات ما بعد البيع وتذاكر الدعم.",
    roleDeveloper: "مطور",
    roleSuperAdmin: "مدير عام فائق",
    roleAdmin: "مدير",
    roleCustomer: "عميل",
    roleGuest: "زائر",
    productCreateMenu: "نشر منتج",
    productsMenu: "قائمة المنتجات",
    merchandisingOverview: "نظرة عامة على التسويق السلعي",
    merchandisingCollection: "مجموعة الاختيار",
    internalOverview: "نظرة عامة وإعدادات",
    internalWorkspace: "المنتج والتنفيذ",
    internalBusiness: "المبيعات والعملاء",
    internalOffice: "مهام المناصب",
    internalMaintenance: "لوحة الصيانة",
    storefrontContent: "محتوى الواجهة الأمامية",
    guestService: "خدمات الزوار",
    customerService: "خدمات العملاء",
    commonAccount: "حسابي",
    siteMaintenanceMenu: "إدارة المناصب",
    positionMaintenanceMenu: "إدارة المستخدمين",
    title: "متجري",
    home: "نظرة عامة على العمليات",
    storeDesign: "إعداد المتجر",
    companyProfile: "ملف الشركة",
    storeBase: "المعلمات الأساسية للمتجر",
    templateStudio: "استوديو القوالب",
    articleManagement: "إدارة المقالات",
    companyProfileMenu: "ملف الشركة",
    companyImages: "صور الشركة",
    designNav: "قوائم التنقل",
    designCarousel: "شريط الصفحة الرئيسية",
    designBanner: "إعدادات البانر",
    faqKnowledge: "قاعدة معرفة الأسئلة الشائعة",
    products: "إدارة المنتجات",
    productCreate: "إضافة تفاصيل المنتج",
    merchandising: "مركز التسويق السلعي",
    procurement: "مركز المشتريات",
    quality: "مركز الجودة",
    logistics: "مزامنة اللوجستيات",
    orders: "الاستفسارات والطلبات",
    customers: "إدارة العملاء",
    marketing: "الحملات التسويقية",
    discounts: "استراتيجيات التسعير",
    finance: "نظرة عامة على المالية",
    financeIncome: "دفتر الإيرادات",
    financeExpenses: "فواتير النفقات",
    financeReceivables: "الذمم المدينة",
    financePayables: "الذمم الدائنة",
    financeInvoices: "إدارة الفواتير",
    financeTax: "إدارة الضرائب",
    financeBudget: "الميزانية والمصاريف",
    financeDaily: "الفواتير اليومية",
    financeMonthly: "الإغلاق الشهري",
    financeYearly: "البيانات السنوية",
    financeReconciliation: "التسوية",
    financeApprovals: "الموافقات والمراجعة",
    financeReports: "التقارير والتصدير",
    analytics: "تحليل البيانات",
    settings: "إعدادات النظام",
    menuCommon: "عام",
    menuInternal: "داخلي",
    menuWorkContent: "محتوى العمل",
    menuMaintenance: "لوحة الصيانة",
    userManagementGroup: "لوحة الصيانة",
    menuGuest: "زائر",
    menuCustomer: "عميل",
    workTargets: "أهداف المهام",
    workProcessing: "معالجة العمل",
    hrEmployee: "سجلات الموظفين",
    hrRecruitment: "إدارة التوظيف",
    hrAttendance: "إدارة الحضور",
    hrOffice: "المهام الإدارية",
    siteMaintenance: "صيانة المناصب",
    permissionMaintenance: "صيانة الصلاحيات",
    positionMaintenance: "إدارة المستخدمين",
    profile: "المعلومات الشخصية",
    password: "تغيير كلمة المرور",
    inquiry: "محادثة الاستفسارات",
    wishlist: "قائمة الرغبات",
    orderProcessing: "معالجة الطلبات",
    afterSales: "خدمة ما بعد البيع",
    profileCardTitle: "ملف الحساب",
    accountId: "معرّف الحساب",
    profileName: "الاسم",
    profileEmail: "البريد الإلكتروني",
    profileRole: "الدور",
    passwordCardTitle: "تغيير كلمة مرور الحساب",
    currentPassword: "كلمة المرور الحالية",
    adminResetPasswordHint: "هذا مخصص للمشرفين لإعادة تعيين كلمات مرور المستخدمين المستهدفين. لا تحتاج إلى كلمة مرور المستخدم الحالية.",
    newPassword: "كلمة المرور الجديدة",
    confirmPassword: "تأكيد كلمة المرور الجديدة",
    savePassword: "تحديث كلمة المرور",
    passwordUpdated: "تم تحديث كلمة المرور بنجاح.",
    inquiryCardTitle: "مركز الاستفسارات",
    inquiryCardBody: "تواصل مع فريق البائعين لمناقشة احتياجات المنتج والتسعير وجداول التسليم.",
    openInquiryCenter: "فتح صفحة الاستفسارات",
    openWhatsappChat: "محادثة WhatsApp",
    permissionSectionTitle: "الصلاحيات الحالية",
    permissionSectionBody: "يتم تحليل الصلاحيات من استجابة تسجيل الدخول وهيكل المنصب.",
    placeholderTodo: "هذا الوحدة مفتوحة للمنصب الحالي. يمكنك توسيع العمليات التجارية المحددة هنا.",
    systemConfigTitle: "مركز إعدادات النظام",
    settingsTabDatabase: "قاعدة البيانات",
    settingsTabDatabaseHint: "إعدادات الاتصال والمجمع",
    settingsTabEmail: "البريد الإلكتروني",
    settingsTabEmailHint: "الهوية والقوالب التفاعلية",
    mysqlHost: "مضيف MySQL",
    mysqlPort: "منفذ MySQL",
    mysqlDatabase: "اسم قاعدة بيانات MySQL",
    mysqlUser: "اسم مستخدم MySQL",
    mysqlPassword: "كلمة مرور MySQL",
    mysqlPoolSize: "حجم مجمع MySQL",
    mysqlConnectTimeoutMs: "مهلة MySQL (مللي ثانية)",
    saveSystemConfig: "حفظ إعدادات النظام",
    systemConfigSavedToast: "تم حفظ إعدادات النظام",
    systemConfigPathLabel: "ملف الإعداد",
    restartRequiredHint: "يلزم إعادة تشغيل خدمة الخلفية لتفعيل إعدادات قاعدة البيانات الجديدة.",
    storefrontTitle: "عنوان الواجهة الأمامية",
    adminTitle: "عنوان لوحة الإدارة",
    seoMetaTitle: "عنوان SEO",
    seoDescription: "وصف SEO",
    seoKeywords: "كلمات SEO المفتاحية",
    seoCanonicalUrl: "الرابط القانوني",
    seoRobots: "تعليمات Robots",
    seoOgTitle: "عنوان Open Graph",
    seoOgDescription: "وصف Open Graph",
    seoOgImage: "رابط صورة Open Graph",
    seoTwitterCard: "نوع بطاقة Twitter",
    seoTwitterSite: "اسم حساب Twitter للموقع",
    saveBaseSettings: "حفظ الإعدادات الأساسية",
    baseSavedToast: "تم حفظ الإعدادات الأساسية",
    hello: "مرحبًا، لنبدأ.",
    askAnything: "اسأل أي شيء...",
    supportLine: "هل لديك أسئلة؟ تواصل مع الدعم",
    addStoreName: "إضافة اسم المتجر",
    firstProduct: "أضف أول منتج لك",
    firstProductDesc: "ابدأ بإضافة منتج وتوفير التفاصيل الأساسية.",
    addProduct: "إضافة منتج",
    importData: "استيراد",
    customizeStore: "خصص متجرك",
    customizeStoreDesc: "اختر قالبًا، وأضف شعارك وألوانك وصورك.",
    customTemplate: "قالب مخصص",
    payments: "إعداد مدفوعات التجارة",
    shipping: "تحقق من أسعار الشحن",
    domain: "نطاق مخصص",
    quickSales: "بسّط المبيعات السوقية",
    quickSalesDesc: "زامن المبيعات والإدارة عبر منصات متعددة.",
    storeSettings: "إعدادات المتجر",
    general: "عام",
    billing: "الفوترة",
    usersPermissions: "المستخدمون",
    paginationPrevious: "السابق",
    paginationNext: "التالي",
    paginationPage: "الصفحة",
    paginationTotal: "من",
    policies: "السياسات",
    businessInfo: "تفاصيل النشاط",
    contactInfo: "معلومات اتصال المتجر",
    defaults: "الافتراضيات",
    businessMode: "نمط العمل",
    b2b: "B2B",
    b2c: "B2C",
    modeSaved: "تم تحديث وضع المتجر",
    modeSavedToast: "تم تبديل نمط العمل بنجاح",
    navSettings: "قائمة التنقل",
    navLabel: "تسمية القائمة الفرعية",
    navPath: "رابط القائمة الفرعية",
    addSubmenu: "إضافة قائمة فرعية",
    saveNavigation: "حفظ القوائم الفرعية",
    navSavedToast: "تم حفظ قائمة التنقل",
    bannerSettings: "قائمة البانرات",
    bannerTitle: "عنوان البانر",
    bannerAnnotation: "شرح الصورة",
    bannerButtonText: "نص الزر",
    bannerButtonLink: "رابط الزر",
    bannerImageUrl: "رابط صورة البانر",
    addBanner: "إضافة بانر",
    removeBanner: "إزالة",
    saveBanners: "حفظ البانرات",
    bannersSavedToast: "تم حفظ قائمة البانرات",
    saveFaqKnowledge: "حفظ الأسئلة الشائعة",
    faqKnowledgeSavedToast: "تم حفظ قاعدة معرفة الأسئلة الشائعة",
    saveCompanyImages: "حفظ صور الشركة",
    companyImagesSavedToast: "تم حفظ إعدادات صور الشركة",
    companyIntroductionTitle: "مقدمة الشركة",
    companyIntroductionHint: "تستخدم لعرض الملف التعريفي والمزايا والقدرات الخدمية.",
    companyIntroductionPlaceholder: "أدخل محتوى مقدمة الشركة...",
    addImageUrl: "إضافة رابط صورة",
    uploadLocalImages: "رفع صور محلية",
    addFaq: "إضافة سؤال شائع",
    saveCarouselImages: "حفظ صور الشريط",
    carouselImagesSavedToast: "تم حفظ صور الشريط",
    close: "إغلاق",
    save: "حفظ",
    create: "إنشاء",
    search: "البحث في العرض الحالي",
    refresh: "تحديث",
    createProduct: "إضافة منتج",
    cancel: "إلغاء",
    edit: "تعديل",
    remove: "حذف",
    systemSnapshot: "لقطة النظام",
    activeSearch: "البحث النشط",
    none: "(لا شيء)",
    orderRecords: "سجلات الطلبات",
    userRecords: "سجلات المستخدمين",
    lastRefresh: "آخر تحديث",
    productsCount: "المنتجات",
    customersCount: "العملاء",
    ordersCount: "الطلبات",
    revenue: "الإيرادات بالدولار الأمريكي",
    localeLabel: "اللغة",
    sku: "SKU",
    name: "الاسم",
    description: "الوصف",
    price: "السعر بالدولار الأمريكي",
    imageUrl: "رابط الصورة",
    category: "الفئة",
    model: "الموديل",
    titleField: "عنوان المنتج",
    detailVideo: "رابط فيديو التفاصيل",
    mainImages: "الصور الرئيسية (6 روابط، كل رابط في سطر)",
    detailImages: "صور التفاصيل (رابط واحد في كل سطر)",
    parameters: "المعلمات (مفتاح:قيمة في كل سطر)",
    openCreateProduct: "فتح نموذج المنتج",
    id: "المعرّف",
    serialNumber: "#",
    userId: "المستخدم",
    actions: "الإجراءات",
    email: "البريد الإلكتروني",
    role: "الدور",
    username: "اسم المستخدم",
    nickname: "الاسم المستعار",
    userRole: "دور المستخدم",
    phone: "الهاتف",
    accountStatus: "حالة الحساب",
    jobTitle: "المسمى الوظيفي",
    registeredAt: "تاريخ التسجيل",
    lastActiveAt: "آخر نشاط",
    statusActive: "نشط",
    statusDisactive: "غير نشط",
    permissions: "الصلاحيات",
    position: "المنصب",
    accessSummary: "الوصول",
    positionName: "اسم المنصب",
    positionKey: "مفتاح المنصب",
    department: "القسم",
    addPosition: "إضافة منصب",
    permissionName: "اسم الصلاحية",
    permissionKey: "مفتاح الصلاحية",
    addPermission: "إضافة صلاحية",
    editPermissions: "تعديل الصلاحيات",
    permissionSelectTitle: "تحديد الصلاحيات",
    permissionSelectedSummary: "المحدد",
    permissionQuickSearchPlaceholder: "بحث سريع حسب المفتاح أو التعليق",
    defaultAdminPosition: "مدير العمليات",
    orderId: "معرّف الطلب",
    total: "الإجمالي",
    status: "الحالة",
    cartItems: "عناصر السلة",
    logout: "تسجيل الخروج",
    changePasswordAction: "تغيير كلمة المرور",
    userPasswordModalTitle: "تعديل كلمة مرور المستخدم",
    userPasswordUpdated: "تم تحديث كلمة مرور المستخدم بنجاح.",
    targetUser: "المستخدم المستهدف",
    userDataResyncedHint: "تم اكتشاف تجاوز في الحقول من الخادم بعد الحفظ. تمت مزامنة أحدث البيانات.",
    userManagementRestrictedHint: "هذه العملية تتطلب صلاحيات أعلى.",
    capability: {
      "admin:overview:read": "قراءة نظرة عامة الإدارة",
      "admin:products:read": "قراءة منتجات الإدارة",
      "admin:products:write": "كتابة منتجات الإدارة",
      "admin:orders:read": "قراءة طلبات الإدارة",
      "admin:orders:write": "كتابة طلبات الإدارة",
      "admin:users:read": "قراءة مستخدمي الإدارة",
      "admin:users:role:write": "كتابة أدوار المستخدمين",
      "admin:users:position:assign": "إسناد مناصب المستخدمين",
      "admin:storefront:read": "قراءة إعدادات الواجهة الأمامية",
      "admin:storefront:write": "كتابة إعدادات الواجهة الأمامية",
      "admin:system-config:read": "قراءة إعدادات النظام",
      "admin:system-config:write": "كتابة إعدادات النظام",
      "shop:profile:read": "قراءة ملف المتجر",
      "shop:password:write": "كتابة كلمة مرور المتجر",
      "shop:orders:read": "قراءة طلبات المتجر",
      "shop:inquiry:write": "معالجة استفسارات المتجر",
      "shop:wishlist:read": "قراءة قائمة الرغبات",
      "shop:orders:processing:read": "قراءة معالجة الطلبات",
      "shop:after-sales:read": "قراءة ما بعد البيع",
      "internal:work:targets:read": "قراءة أهداف العمل",
      "internal:work:processing:read": "قراءة معالجة العمل",
      "internal:maintenance:site:write": "كتابة صيانة الموقع",
      "internal:maintenance:permission:write": "كتابة صيانة الصلاحيات",
      "internal:maintenance:position:write": "كتابة صيانة المناصب",
      "shop:products:read": "قراءة منتجات المتجر",
      "shop:storefront:read": "قراءة واجهة المتجر",
      "internal:system:config:read": "قراءة إعدادات النظام الداخلية",
      "internal:system:config:write": "كتابة إعدادات النظام الداخلية",
      "internal:security:audit:read": "قراءة تدقيق الأمان",
      "internal:security:session:revoke": "إلغاء الجلسة",
      "internal:integration:manage": "إدارة التكاملات",
      "admin:users:write": "كتابة مستخدمي الإدارة",
      "admin:users:password:reset": "إعادة تعيين كلمة مرور المستخدم",
      "admin:users:delete": "حذف مستخدم الإدارة",
      "crm:customer:read": "قراءة ملف العميل",
      "crm:customer:write": "كتابة ملف العميل",
      "crm:customer:assign": "إسناد ملكية العميل",
      "website:content:read": "قراءة محتوى الموقع",
      "website:content:write": "كتابة محتوى الموقع",
      "website:navigation:write": "كتابة تنقل الموقع",
      "website:banner:write": "كتابة بانرات الموقع",
      "website:seo:write": "كتابة SEO الموقع",
      "website:theme:write": "كتابة سمة الموقع",
      "website:publish": "نشر محتوى الموقع",
      "admin:products:create": "إنشاء منتجات الإدارة",
      "admin:products:delete": "حذف منتجات الإدارة",
      "merchandising:selection:read": "قراءة مجموعة الاختيار",
      "merchandising:selection:write": "كتابة مجموعة الاختيار",
      "catalog:pricing:write": "كتابة تسعير الكتالوج",
      "catalog:inventory:write": "كتابة مخزون الكتالوج",
      "catalog:translation:write": "كتابة ترجمة الكتالوج",
      "sales:inquiry:read": "قراءة استفسارات المبيعات",
      "sales:inquiry:reply": "الرد على استفسارات المبيعات",
      "sales:quotation:create": "إنشاء عرض سعر مبيعات",
      "sales:quotation:approve": "اعتماد عرض سعر المبيعات",
      "sales:contract:write": "كتابة عقد المبيعات",
      "sales:sample:manage": "إدارة سير عمل العينات",
      "order:status:update": "تحديث حالة الطلب",
      "order:split:merge": "تقسيم أو دمج الطلبات",
      "procurement:purchase:write": "كتابة أوامر الشراء",
      "production:plan:write": "كتابة خطط الإنتاج",
      "qa:inspection:write": "كتابة فحوص الجودة",
      "logistics:shipment:write": "كتابة معلومات الشحن",
      "logistics:tracking:read": "قراءة تتبع اللوجستيات",
      "trade:customs:doc:write": "كتابة مستندات الجمارك",
      "finance:invoice:read": "قراءة الفواتير",
      "finance:invoice:write": "كتابة الفواتير",
      "finance:payment:read": "قراءة المدفوعات",
      "finance:payment:write": "كتابة المدفوعات",
      "finance:refund:approve": "اعتماد الاسترداد",
      "finance:reconciliation:write": "كتابة التسوية المالية",
      "finance:tax:write": "كتابة معلومات الضرائب",
      "marketing:campaign:read": "قراءة الحملات التسويقية",
      "marketing:campaign:write": "كتابة الحملات التسويقية",
      "marketing:coupon:write": "كتابة القسائم",
      "marketing:lead:export": "تصدير العملاء المحتملين",
      "analytics:dashboard:read": "قراءة لوحة التحليلات",
      "analytics:report:export": "تصدير تقارير التحليلات",
      "support:ticket:read": "قراءة تذاكر الدعم",
      "support:ticket:write": "كتابة تذاكر الدعم",
      "support:return:approve": "اعتماد طلب الإرجاع",
      "support:complaint:handle": "معالجة شكاوى العملاء",
      "office:announcement:write": "كتابة إعلانات المكتب",
      "office:document:read": "قراءة مستندات المكتب",
      "office:document:write": "كتابة مستندات المكتب",
      "office:workflow:approve": "اعتماد سير عمل المكتب",
      "office:meeting:manage": "إدارة جدول الاجتماعات",
      "hr:employee:read": "قراءة سجلات الموظفين",
      "hr:employee:write": "كتابة سجلات الموظفين"
    }
  }
};